<script lang="ts">
	//UI
	import { DefaultButton } from "@hitit/new_ui";
	//Utils
	import { createEventDispatcher } from "svelte";
	//Types
	//Props
	export let saveButtonDisable = false;
	//Constants
	const dispatch = createEventDispatcher();
	//Variables
	//Functions
	function cancel() {
		dispatch("CANCEL");
	}

	function save() {
		dispatch("SAVE");
	}
	//Do

</script>

<div class="buttons">
	<div class="cancel">
		<DefaultButton background={'#bcbfc3'} on:click={cancel}>
			<span>취소</span>
		</DefaultButton>
	</div>
	<div class="save">
		<DefaultButton
			background={'#6d6f76'}
			disabled={saveButtonDisable}
			on:click={save}>
			<span>확인</span>
		</DefaultButton>
	</div>
</div>

<style lang="scss">
	.buttons {
		width: 100%;
		gap: 10px;
		display: flex;
		justify-content: flex-end;
		margin-top: 20px;
		height: 40px;
		:global(button) {
			display: flex;
			justify-content: center;
			align-items: center;
			width: 100%;
			height: 40px;
		}
		span {
			font-size: 1.25rem;
			font-weight: 500;
			color: white;
		}
		.cancel {
			width: 92px;
		}

		.save {
			flex-grow: 1;
		}
	}

</style>
